function translateFilter(translateService, $sce) {
    'ngInject';

    const f = (text, values) => {
        return $sce.trustAsHtml(translateService.translate(text, values)) || text;
    };

    f.$stateful = true;

    return f;
}

export default translateFilter;